import type { StateCreator } from 'zustand'

import type { AccountStore } from '../types'

import type { AccountDataSlice } from './account-data.slice.type'

export const createAccountDataSlice: StateCreator<
  AccountStore,
  [['zustand/immer', never]],
  [],
  AccountDataSlice
> = () => ({
  profile: null,
  signInMethods: [],
  twoFactorStatus: null,
  themePreference: 'system',
  loading: false,
  error: null,
})
